import React from 'react';

import { Box, Skeleton, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

const SkeletonWrapper = Box.withConfig({
  padding: { base: '$4', md: '$8' },
  backgroundColor: theme.token('background-hero-light'),
});

// TODO: This component is used in HomePage for the SimpleHomePage skeleton. It'would be updated to the new design.
export const HeroSkeleton = () => {
  return (
    <SkeletonWrapper flexDir={{ base: 'column', md: 'row-reverse' }}>
      <Box p="$6" width={{ base: '100%', md: '50%' }}>
        <Skeleton h="$48" w="$48" mb="$3" rounded="full" mx="auto" />
      </Box>
      <VStack width={{ base: '100%', md: '50%' }} justifyContent="center">
        <Skeleton.Text mb="$4" />
        <Skeleton
          h="$10"
          rounded="full"
          mb="$2"
          startColor="token.background-skeleton-loader-cta-start"
          endColor="token.background-skeleton-loader-cta-end"
        />
      </VStack>
    </SkeletonWrapper>
  );
};
